import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Section, Eyebrow, SectionTitle } from './ui.jsx';
import { displayFont, monoFont, tokens } from '../theme.js';

export default function Platform() {
  const { t } = useTranslation();
  const items = t('platform.items', { returnObjects: true });

  return (
    <Section id="platform">
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '0.8fr 1.2fr' }, gap: { xs: 5, md: 8 }, alignItems: 'start' }}>
        <Box>
          <Eyebrow>{t('platform.eyebrow')}</Eyebrow>
          <SectionTitle>{t('platform.title')}</SectionTitle>
          <Typography sx={{ color: 'text.secondary', maxWidth: '52ch', mt: -3 }}>{t('platform.body')}</Typography>
        </Box>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
          {items.map((item) => (
            <Paper key={item.title} variant="outlined" sx={{ p: 3, borderLeft: `3px solid ${tokens.teal}` }}>
              <Typography sx={{ fontFamily: monoFont, color: 'primary.dark', fontSize: '0.67rem', letterSpacing: '0.08em' }}>{item.label}</Typography>
              <Typography sx={{ fontFamily: displayFont, fontWeight: 600, mt: 1 }}>{item.title}</Typography>
              <Typography sx={{ color: 'text.secondary', fontSize: '0.88rem', mt: 0.75 }}>{item.body}</Typography>
            </Paper>
          ))}
        </Box>
      </Box>
    </Section>
  );
}
